<template>
    <div class="modal fade" tabindex="-1" role="dialog" id="followTeamModal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title">Follow {{ team.name }}</h4>
                </div>
                <div class="modal-body follow-team-content">
                    <p class="follow-team-subhead">
                        Sign up to receive notifications when {{ team.name }} creates or updates a Need.
                    </p>
                    <div class="row">
                        <div class="col-xs-6" v-show="smsEnabled">
                            <input type="checkbox" v-model="followViaSms" /> Follow Via SMS Text
                        </div>
                        <div class="col-xs-6">
                            <input type="checkbox" v-model="followViaEmail" /> Follow Via Email
                        </div>
                    </div>
                    <div class="row mt-30">
                        <div :class="{'col-xs-6': smsEnabled && followViaSms && followViaEmail, 'col-xs-12': !(smsEnabled && followViaSms && followViaEmail)}"
                             v-show="followViaSms">
                            <input type="text"
                                   id="followTeamSMS"
                                   v-mask="'( ### ) ### - ####'"
                                   class="form-control"
                                   :disabled="submitting"
                                   placeholder="Enter your mobile number"
                                   v-model="sms" />
                        </div>
                        <div :class="{'col-xs-6': smsEnabled && followViaSms && followViaEmail, 'col-xs-12': !(smsEnabled && followViaSms && followViaEmail)}"
                             v-show="followViaEmail">
                            <input type="text"
                                   id="followTeamEmail"
                                   class="form-control"
                                   :disabled="submitting"
                                   placeholder="Enter your email"
                                   v-model="email" />
                        </div>
                    </div>
                    <div class="row mt-20" v-if="team.follower_settings.ask_for_name">
                        <div class="col-xs-6">
                            <input type="text"
                                   class="form-control"
                                   v-model="first_name"
                                   placeholder="First Name"
                                   :disabled="submitting" />
                        </div>
                        <div class="col-xs-6">
                            <input type="text"
                                   class="form-control"
                                   v-model="last_name"
                                   placeholder="Last Name"
                                   :disabled="submitting" />
                        </div>
                    </div>
                    <div class="row mt-20" v-if="team.follower_settings.ask_for_address">
                        <div class="col-xs-12">
                            <input type="text"
                                   class="form-control"
                                   v-model="address"
                                   id="addressInput"
                                   placeholder="Address"
                                   :disabled="submitting" />
                        </div>
                        <div class="col-xs-4 mt-20">
                            <input type="text"
                                   class="form-control"
                                   v-model="city"
                                   placeholder="City"
                                   :disabled="submitting" />
                        </div>
                        <div class="col-xs-4 mt-20">
                            <input type="text"
                                   class="form-control"
                                   v-model="region"
                                   placeholder="State"
                                   :disabled="submitting" />
                        </div>
                        <div class="col-xs-4 mt-20">
                            <input type="text"
                                   class="form-control"
                                   v-model="postal_code"
                                   placeholder="Zip"
                                   :disabled="submitting" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <custom-question v-for="question in custom_questions"
                                             :key="question.created_at"
                                             class="mt-20"
                                             :question="question"
                                             :clear="clear_custom_questions"
                                             @answered="customQuestionAnswered"></custom-question>
                        </div>
                    </div>
                </div>
                <div class="alert alert-danger mt-30" v-show="error">
                    <h4>Something went wrong</h4>
                    <p>
                        Something went wrong trying to follow {{ team.name }}. Please try again. If this keeps happening
                        please contact us at {{ helpEmail }} .
                    </p>
                </div>
                <div id="recaptchaBadge"></div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    <button type="button"
                            id="followTeamSubmit"
                            :disabled="!formReady() || submitting"
                            @click="submit()"
                            class="btn btn-primary">Follow</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import { mask } from 'vue-the-mask';
    import CustomQuestion from '../../../components/CustomQuestion';
    import { validEmail, validPhoneNumber } from '../../../helpers/validators';
    import { successAlert } from '../../../helpers/alerts';
    import { getRecaptchaToken } from '../../../helpers/google';
    import { storeLocalFollowers } from '../../../helpers/follower-tracker';

    export default {
        props: ['team', 'open'],
        directives: { mask },
        components: { CustomQuestion },
        watch: {
            open(time) {
                if(time) {
                    $("#followTeamModal").modal("show");
                    if(!this.autocomplete) {
                        /*
                        this.autocomplete = new google.maps.places.Autocomplete(
                            document.getElementById("addressInput"), {types: ['geocode']}
                        );
                        this.autocomplete.setFields(['address_components']);
                        this.autocomplete.addListener('place_changed', this.placeSelected);
                         */
                    }
                }
            }
        },
        data() {
            let smsEnabled = this.team && this.team.sms && !this.team.sms_disabled;
            return {
                smsEnabled,
                followViaEmail: !smsEnabled,
                followViaSms: true,
                email: '',
                sms: '',
                submitting: false,
                error: false,
                helpEmail: window.help_email ? window.help_email : 'ben@cheerfully.com',
                first_name: '',
                last_name: '',
                address: '',
                city: '',
                region: '',
                postal_code: '',
                autocomplete: null,
                custom_questions: this.team.follower_settings.custom_questions ? this.team.follower_settings.custom_questions : [],
                custom_answers: [],
                clear_custom_questions: 0,
            }
        },
        methods: {
            async submit() {
                if(!this.formReady()) {
                    return;
                }
                this.submitting = true;
                this.error = false;
                let data = {
                    team_id: this.team.id,
                    _token: window.csrf_token,
                    recaptcha_token: await getRecaptchaToken('follow')
                };
                if(this.followViaEmail) {
                    data['email'] = this.email;
                }
                if(this.followViaSms && this.smsEnabled) {
                    data['phone_number'] = this.sms.replace(/\D/g, '')
                }
                if(this.team.follower_settings.ask_for_name) {
                    data['first_name'] = this.first_name;
                    data['last_name'] = this.last_name;
                }
                if(this.team.follower_settings.ask_for_address) {
                    data['address'] = this.address;
                    data['city'] = this.city;
                    data['region'] = this.region;
                    data['postal_code'] = this.postal_code;
                }
                if(this.custom_answers) {
                    data['custom_answers'] = this.custom_answers;
                }
                axios.post('/team/follow', data)
                    .then(response => {
                        let followers = response.data.followers;
                        let followerIds = followers.map(follower => follower.id);
                        storeLocalFollowers(followerIds);
                        let hasBoth = followers.length >= 2;
                        let contactText = 'email and phone number';
                        if(!hasBoth && followers[0].email) {
                            contactText = 'email';
                        }
                        if(!hasBoth && followers[0].phone_number) {
                            contactText = 'phone number';
                        }
                        if(window.localStorage) {
                            const followerIds = followers.map(follower => follower.id);
                            window.localStorage.setItem('lastFollowers', JSON.stringify(followerIds));
                        }
                        this.resetForm();
                        $("#followTeamModal").modal('hide');
                        setTimeout(() => {
                            successAlert(`You will receive a message soon asking you to click a link to verify your ${contactText}.
                            You will start receiving Need notifications from ${this.team.name} once you have been verified.`)
                        }, 1000);
                    })
                    .catch(() => {
                        this.error = true;
                    })
                    .finally(() => {
                        this.submitting = false;
                    });
            },
            formReady() {
                if(
                    (this.followViaEmail && !validEmail(this.email)) ||
                    (this.followViaSms && this.smsEnabled && !validPhoneNumber(this.sms))
                ) {
                    return false;
                }
                if(this.team.follower_settings.ask_for_name && (!this.first_name || !this.last_name)) {
                    return false;
                }
                if(this.team.follower_settings.ask_for_address && (!this.address || !this.city || !this.region || !this.postal_code)) {
                    return false;
                }
                if(
                    this.custom_questions.filter(question => question.required).length !==
                    this.custom_answers.filter(answer => (answer.answer && answer.question.required)).length
                ) {
                    return false;
                }
                return true;
            },
            resetForm() {
                this.followViaSms = true;
                this.followViaEmail = !this.smsEnabled;
                this.email = '';
                this.sms = '';
                this.custom_answers = [];
                this.first_name = '';
                this.last_name = '';
                this.address = '';
                this.city = '';
                this.region = '';
                this.postal_code = '';
                this.clear_custom_questions = (new Date()).getTime();
            },
            placeSelected() {
                let placeData = this.autocomplete.getPlace();
                if(!Array.isArray(placeData.address_components) || placeData.address_components.length === 0) {
                    return;
                }
                let street_number = '';
                let route = '';
                for(let place of placeData.address_components) {
                    if(place.types.indexOf('street_number') >= 0) {
                        street_number = place.short_name;
                        continue;
                    }
                    if(place.types.indexOf('route') >= 0) {
                        route = place.short_name;
                        continue;
                    }
                    if(place.types.indexOf('locality') >= 0) {
                        this.city = place.long_name;
                        continue;
                    }
                    if(place.types.indexOf('administrative_area_level_1') >= 0) {
                        this.region = place.long_name;
                        continue;
                    }
                    if(place.types.indexOf('postal_code') >= 0) {
                        this.postal_code = place.long_name;
                    }
                }
                if(street_number || route) {
                    this.address = street_number + ' ' + route;
                }
            },
            customQuestionAnswered(answer) {
                if(this.custom_answers.length === 0) {
                    this.custom_answers.push(answer);
                    return;
                }
                for(let i = 0; i < this.custom_answers.length; i++) {
                    if(
                        this.custom_answers[i].question.created_at === answer.question.created_at &&
                        this.custom_answers[i].question.question === answer.question.question &&
                        this.custom_answers[i].answer !== answer.answer
                    ) {
                        this.custom_answers[i] = answer;
                        return;
                    }
                }
                this.custom_answers.push(answer);
            }
        }
    }
</script>

<style scoped>
    .follow-team-content {
        padding: 20px;
    }
    .follow-team-input {
        height: 40px;
    }
</style>
